import React from 'react';
import { ClickAndCollectLogo } from '@sainsburys-tech/bolt-icons';
import * as Styled from './ClickAndCollect.styles';

var ClickAndCollect = function ClickAndCollect(_ref) {
  var usage = _ref.usage;
  return /*#__PURE__*/React.createElement(Styled.ClickAndCollectWrapper, null, /*#__PURE__*/React.createElement(Styled.ClickAndCollectContent, {
    usage: usage
  }, /*#__PURE__*/React.createElement(Styled.ClickAndCollectBrand, {
    usage: usage
  }, /*#__PURE__*/React.createElement(Styled.ClickAndCollectBrandIcon, {
    usage: usage,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(ClickAndCollectLogo, {
    fill: "white"
  })), "Click & collect"), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, " | "), usage === 'availability' ? /*#__PURE__*/React.createElement(Styled.ClickAndCollectMessage, null, "Pay online collect in-store") : /*#__PURE__*/React.createElement(Styled.ClickAndCollectMessage, null, "Remember to pay online before you collect in-store")));
};

export default ClickAndCollect;